import { ApiHandler } from '@eshop/api-client'

import type { FormState } from '#/App'

import type { FetchResponse } from '#/local/type'

export const sendReport = async (data: FormState): Promise<{ status: true } | { errors: FetchResponse[], status: false }> => {
    const body = new FormData()

    for (const [key, value] of Object.entries(data)) {
        if (key === 'files') {
            for (const file of value as File[]) {
                body.append(key, file)
            }
            continue
        }
        body.append(key, `${value}`)
    }

    const api = new ApiHandler({
        path: '/form/rental-machine-damage-report-save',
        method: 'POST',
        body,
        defaultContentType: false,
    })

    api.addResponseHandler('4xx', async (response) => {
        if (response.status === 400) {
            return api.getData(true)
        }
        await api.handleError()
    })

    const result = await api.send()

    if (result === undefined) {
        return { status: true }
    }

    return {
        status: false,
        errors: result.errors as FetchResponse[],
    }
}
